class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll(
      "input[type='checkbox'], input[type='radio']",
    );
    this.form = this.querySelector("form");
    this.sectionId = this.dataset.sectionId;
    this.collectionContainer = this.closest("#product-grid-section");
    this.closeButton = this.querySelectorAll("[data-close");
    this.filterLinks = this.querySelectorAll("[data-filter-link]");
  }

  connectedCallback() {
    this.filterLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const url = new URL(e.currentTarget.href);
        this.fetchCollection(url.href);
      });
    });

    this.inputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        e.preventDefault();

        const label = e.currentTarget.closest("label");
        const isChecked = e.currentTarget.checked;

        if (isChecked) {
          label.classList.add("active");
        } else {
          label.classList.remove("active");
        }

        this.handleFilter();
      });
    });

    this.closeButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.remove("mobile-filter-open");

        //dispatch mobile-filter:close event
        const event = new CustomEvent("mobile-filter:close", {
          bubbles: true,
        });
        this.dispatchEvent(event);
      });
    });

    const radioInputs = this.querySelectorAll("input[type='radio']");

    if (radioInputs.length > 0) {
      if (Array.from(radioInputs).some((input) => input.checked)) {
        return;
      }

      radioInputs[0].checked = true;
      const label = radioInputs[0].closest("label");
      label.classList.add("active");
    }
  }

  handleFilter() {
    const searchParams = this.createSearchParams(this.form);
    this.submitForm(searchParams);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  submitForm(searchParams) {
    const url = new URL(window.location.href);

    // Clear existing search params
    url.searchParams.forEach((_, key) => {
      if (key !== "") {
        url.searchParams.delete(key);
      }
    });

    // Append new search params
    searchParams.forEach((value, key) => {
      url.searchParams.append(key, value);
    });

    this.fetchCollection(url.href);
  }

  fetchCollection(url) {
    history.replaceState("", "", url);
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const newContainer = parsedHTML.querySelector("#product-grid-section");

        this.collectionContainer.innerHTML = newContainer.innerHTML;
        document.dispatchEvent(new CustomEvent("collection:updated"));
      });
  }
}

if (!customElements.get("collection-filters")) {
  customElements.define("collection-filters", CollectionFilters);
}
